export default "__VITE_ASSET__CK27OEuW__"